<ng-content></ng-content>

<div class="menu-container">
  <div class="sidebar-menu">
    <div
      *ngFor="let item of items"
      class="tree-item"
      [class.active-item]="item.featureName === activeFeature"
      [title]="item.text"
      (click)="onItemClick2(item, $event)"
    >
      <img
        [src]="item.featureName === activeFeature ? item.selectedIcon : item.icon"
        class="item-icon"
      />
      <span class="item-text">{{ item.text }}</span>
    </div>
  </div>
</div>